import { render, staticRenderFns } from "./partShipment.vue?vue&type=template&id=9727dff0"
import script from "./partShipment.vue?vue&type=script&lang=js"
export * from "./partShipment.vue?vue&type=script&lang=js"
import style0 from "./partShipment.vue?vue&type=style&index=0&id=9727dff0&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports